/** Class to hide PII from FullStory */
/** See more: https://help.fullstory.com/hc/en-us/articles/360020623574-How-do-I-protect-my-users-privacy-in-Fullstory */
export const EXCLUDE_CLASS = "fs-exclude";
export const MASK_CLASS = "fs-mask";
export { EXCLUDE_CLASS as SENSITIVE_CLASS };

export function sensitiveClassName(sensitive: "exclude" | "mask" | undefined): string | undefined {
  if (sensitive === "exclude") {
    return EXCLUDE_CLASS;
  }
  if (sensitive === "mask") {
    return MASK_CLASS;
  }
}
